// PacketMirrorForm.js
import React, { useState, useEffect, useCallback } from 'react';
import { toast } from 'react-toastify';
import { get as _get, cloneDeep as _cloneDeep } from 'lodash';
import CustomStepper from '../../../../components/stepper';
import { makeStyles } from "@mui/styles";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from '@mui/material/FormControlLabel';
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import FormHelperText from "@mui/material/FormHelperText";
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import Checkbox from '@mui/material/Checkbox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { FormLabel } from '@mui/material';
import Validator, {
    useValidate,
} from "../../../../components/validator";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import MultipleInputs from '../../../../components/multipleinputs';
import Auth from "../../../../data/auth-service";
import PacketMirrorService from '../../../../data/packetmirror-service';
import LoadBalancerService from '../../../../data/loadbalancer-service';
import GCPService from '../../../../data/gcp-service';

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
    },
    button: {
        marginRight: theme.spacing(1),
    },
    customRadio: {
        '& .Mui-checked': {
            color: 'blue',
        },
    },
    chip: {
        margin: 2,
        background: theme.palette.secondary.main,
        color: '#FFF',
        fontSize: 16,
        '& .MuiChip-deleteIcon': {
            color: 'rgba(255, 255, 255, 0.75)',
        },
    },
}));


const CreatePacketMirror = () => {
    const classes = useStyles();
    const navigate = useNavigate();
    const location = useLocation();
    const gcpPerms = Auth.permissions.get("GCP");
    const [readonly] = useState(!gcpPerms.write);
    const [isUpdate, setIsUpdate] = useState(false);
    const [activeStep, setActiveStep] = useState(0);
    const packetMirrorForm = useValidate({});
    const [isNextButtonDisabled, setIsNextButtonDisabled] = useState(false);
    const [peeredVPCnetwork, setPeeredVPCNetwork] = useState(0);
    const routeParams = useParams();
    const [networkType, setNetworkType] = useState("within");
    const [mirrorDefault, setMirrorDefault] = useState(true);
    const [specificProtocol, setSpecificProtocol] = useState(false);
    const [ipv4Ranges, setIPv4Ranges] = useState([]);
    const [ipv6Ranges, setIPv6Ranges] = useState([]);
    const [allIPv4, setAllIpv4] = useState(true);
    const [allIPv6, setAllIpv6] = useState("");
    const [regionList, setRegionList] = useState([]);
    const [sharedsubNetworkList, setSharedsubNetworkList] = useState([]);
    const [sharedNetworkList, setsharedNetworkList] = useState([])
    const [networkList, setNetworkList] = useState([]);
    const [instanceOptions, setInstanceOptions] = useState([]);
    const [sharednetworkinstanceOptions, setSharedNetworkInstanceOptions] = useState([])
    const [serviceProjectOptions, setServiceProjectOptions] = useState([]);
    const [collectorDestinationList, setCollectorDestinationList] = useState([]);
    const [project, setProject] = useState(location?.state?.hostproject || null)
    const [serviceProjects, setServiceProjects] = useState([])
    const [sharedNetwork, setSharedNetwork] = useState({
        sharedNetworkName: null,
        network: {
            url: null
        }
    });
    const [network, setNetwork] = useState({
        networkName: null,
        network: {
            url: null
        }
    });
    const ranges = ipv4Ranges.concat(ipv6Ranges)
    const [enableSubnetwork, setEnableSubnetwork] = useState(false);
    const [enableNetworktags, setEnableNetworkTags] = useState(false);
    const [enableInstances, setEnableInstances] = useState(false);
    const [updatepacketMirrorData, setUpdatepacketMirrorData] = useState({})

    const steps = ['Define Policy', 'Select VPC Network', 'Select Mirrored Source', 'Select Collector Destination', 'Select Mirrored Traffic'];
    const [packetMirrorData, setPacketMirrorData] = useState({
        name: null,
        description: "",
        region: null,
        network: {
            url: null
        },
        priority: 1000,
        collectorIlb: {
            url: null
        },
        mirroredResources: {
            subnetworks: [],
            instances: [],
            tags: []
        },
        filter: {
            cidrRanges: [],
            IPProtocols: [],
            direction: "BOTH"
        },
        enable: "TRUE",
        regionName: null,
        networkName: null,
        ILBName: null,
        zoneName: null,
        subnetworkName: null,
        sharedNetworkName: null,
    })

    const zonesList = packetMirrorData.region ? regionList.filter((region) => region.name == packetMirrorData.regionName).map((region) => region.zones).flat() : [];
    const subnetworkList = packetMirrorData.network ? networkList.filter((network) => network.name === packetMirrorData.networkName).map(network => network.subnetworks).flat() : [];
    const [filteredForwardingrules, setFilteredForwardingRules] = useState([])
    const [nameError, setNameError] = useState("");
    const nameReg = new RegExp('^[a-z0-9-]+$');

    const filterCIDRRanges = (cidrRanges) => {
        const ipv4Regex = /^(\d{1,3}\.){3}\d{1,3}\/\d{1,2}$/;
        const ipv6Regex = /^[0-9a-fA-F:]+\/\d{1,3}$/;

        const ipv4Ranges = [];
        const ipv6Ranges = [];

        cidrRanges.forEach((range) => {
            if (ipv4Regex.test(range)) {
                ipv4Ranges.push(range);
            } else if (ipv6Regex.test(range)) {
                ipv6Ranges.push(range);
            }
        });

        return { ipv4Ranges, ipv6Ranges };
    };

    const filterInstancesBynetwork = (instances, networkUrl) => {
        return instances.filter((instance) => {
            return instance.networkInterfaces.some((networkInterface) => {
                return networkInterface.name === 'nic0' && networkInterface.network === networkUrl;
            });
        });
    };


    const filterprojectInstancesBynetwork = (instances, networkUrl) => {
        return instances.filter((instance) => {
            return instance.networkInterfaces.some((networkInterface) => {
                return networkInterface.network === networkUrl;
            });
        });
    };

    const filterAggregatedInstancesByRegion = (aggregatedInstanceList) => {
        return Object.keys(aggregatedInstanceList)
            .filter((zone) =>
                zonesList.some((zoneItem) => zone.includes(zoneItem.name)) && aggregatedInstanceList[zone].instances
            )
            .reduce((allInstances, zone) => {
                return allInstances.concat(aggregatedInstanceList[zone].instances || []);
            }, []);
    };

    const filterProjectAggregatedInstancesByRegion = (aggregatedInstanceList) => {
        const instances = [];
        for (const [iter, data] of Object.entries(aggregatedInstanceList)) {
            const zonematched = Object.keys(data)
                .filter((zone) =>
                    zonesList.some((zoneItem) => zone.includes(zoneItem.name)) && data[zone].instances
                )
                .reduce((allInstances, zone) => {
                    return allInstances.concat(data[zone].instances || []);
                }, []);
            instances.push(...zonematched);
        }
        return instances;
    };


    const getInstances = async (network) => {
        try {
            let data = await GCPService.getAggregatedInstances();
            if (data.items) {
                let instances = filterAggregatedInstancesByRegion(data.items)
                instances = filterInstancesBynetwork(instances, network)
                setInstanceOptions(instances);
            } else {
                setInstanceOptions([]);
            }

        } catch (error) {
            console.log(`Error while fetch  Aggregated Instances: ${error.message}`);
        }
    };

    const getInstancesUsingSharednetwork = async (network) => {
        try {
            if (serviceProjects.length > 0) {
                const promises = serviceProjects.map(async (project) => {
                    try {
                        const response = await GCPService.getAggregatedInstancesByProject(project)
                        return await response.items
                    } catch (error) {
                        console.log(error.message)
                    }
                })
                const results = await Promise.all(promises)
                const filteredResults = results.filter(item => item !== undefined);
                const data = filterProjectAggregatedInstancesByRegion(filteredResults)

                let instances = filterprojectInstancesBynetwork(data, network)

                setSharedNetworkInstanceOptions(instances);
            } else {
                setSharedNetworkInstanceOptions([])
            }

        } catch (error) {
            console.log(`Error while fetch  Aggregated Instances: ${error.message}`);
        }
    };

    useEffect(() => {

        const fetchData = async () => {
            try {
                const [regions] = await Promise.all([
                    GCPService.getRegionsMap(),
                ]);
                let regionItems = [...regions].map(([regionName, { selfLink, zones }]) => {
                    let zoneItems = [...zones].map(([zoneName, zoneSelfLink]) => ({ 'name': zoneName, 'selfLink': zoneSelfLink }));
                    return { 'name': regionName, 'selfLink': selfLink, 'zones': zoneItems };
                });
                setRegionList(regionItems);
            } catch (error) {
                console.error(`Error fetching data: ${error.message}`);
            }
        };

        const fetchHost = async () => {
            try {
                const host = await GCPService.getXPNhosts();
                if (host.name) {
                    setProject(host.name)
                }
                else {
                    throw new Error(host)
                }
            }
            catch (error) {
                console.log(`Error while fetching XPN hosts :${error.message}`)
            }
        }

        fetchData();
        fetchHost();
    }, []);



    useEffect(() => {

        const extractProjectsbyinstance = (data) => {
            if (data?.instances && data?.instances?.length > 0) {
                const projects = data.instances.map(instance => {
                    const urlProject = instance.url?.match(/\/projects\/([^/]+)/)?.[1];
                    return urlProject;
                });
                setServiceProjects(projects)
            }
        }

        if (routeParams.id) {
            setIsUpdate(true)
            if (location?.state?.data) {
                let data = _cloneDeep(location.state.data);

                if (project && data.network.url.includes(project)) {
                    setNetworkType("shared")
                    getInstancesUsingSharednetwork(data.network.url)
                    extractProjectsbyinstance(data.mirroredResources)
                    data.sharedNetworkName = GCPService.selfLinktoName(data.network.url)
                } else {
                    getInstances(data.network.url)
                    data.networkName = GCPService.selfLinktoName(data.network.url);
                }
                if (data.region) {
                    data.regionName = GCPService.selfLinktoName(data.region);
                    fetchForwardingrulesByregion(data.regionName)
                }
                if (data.collectorIlb.url) {
                    data.ILBName = GCPService.selfLinktoName(data.collectorIlb.url);
                }

                if (data.mirroredResources?.instances?.length > 0) {
                    setEnableInstances(true)
                }
                if (data.mirroredResources?.subnetworks?.length > 0) {
                    setEnableSubnetwork(true)
                }
                if (data.mirroredResources?.tags?.length > 0) {
                    setEnableNetworkTags(true)
                }
                if (data.filter?.cidrRanges?.length > 0 || data.filter?.IPProtocols?.length > 0 || data.filter.direction != "BOTH") {

                    if (data.filter?.cidrRanges?.length > 0) {
                        const { ipv4Ranges, ipv6Ranges } = filterCIDRRanges(data.filter.cidrRanges);

                        const defaultIpv4 = ipv4Ranges.includes('0.0.0.0/0');
                        const defaultIpv6 = ipv6Ranges.includes('::/0');
                        if (defaultIpv4) {
                            setAllIpv4(true)
                        }
                        else {
                            setAllIpv4(false)
                            setIPv4Ranges(ipv4Ranges);
                        }
                        if (ipv6Ranges && defaultIpv6) {
                            setAllIpv6("all")
                        }
                        else if (ipv6Ranges.length === 0) {
                            setAllIpv6("")

                        } else {
                            setAllIpv6("custom")
                            setIPv6Ranges(ipv6Ranges);
                        }
                    }
                    setMirrorDefault(false)
                    if (data.filter?.IPProtocols?.length > 0) {
                        setSpecificProtocol(true);

                    }
                }
                setUpdatepacketMirrorData(data);
                setPacketMirrorData(_cloneDeep(data));
            }
        }
    }, [routeParams.id, project]);




    useEffect(() => {
        const fetchSharednetworks = async () => {
            try {
                if (project) {
                    const sharednetworks = await GCPService.getSharedNetwork(project);
                    setsharedNetworkList(sharednetworks.items)
                }
            } catch (error) {
                console.log(`Error while fetching shared networks: ${error.message}`)
            }
        }

        const fetchNetworks = async () => {
            try {
                const networks = await GCPService.getNetworksMap();
                let networkItems = [...networks].map(([networkName, { selfLink, subnetworks }]) => {
                    let subnetworkItems = [...subnetworks].map(([subnetworkName, subnetworkSelfLink]) => ({ 'name': subnetworkName, 'selfLink': subnetworkSelfLink }));
                    return { 'name': networkName, 'selfLink': selfLink, 'subnetworks': subnetworkItems };
                });
                setNetworkList(networkItems);
            } catch (error) {
                console.log(`Error while fetching networks: ${error.message}`);
            }
        };

        const fetchSharedsubnetworks = async () => {
            try {
                if (project && packetMirrorData && packetMirrorData.regionName) {
                    await GCPService.getSharedVPC(project, packetMirrorData.regionName).then(res => {
                        setSharedsubNetworkList(res.items)
                    })
                }
            } catch (error) {
                console.log(`Error while fetching shared subnetworks: ${error.message}`)
            }

        }

        const fetchXPNResources = async () => {
            try {
                if (project) {
                    await GCPService.getXPNResources(project).then(res => {
                        setServiceProjectOptions(res.resources)
                    })
                }
            } catch (error) {
                console.log(`Error while fetching XPN resources${error.message}`)
            }
        }

        fetchNetworks();
        fetchSharednetworks();
        fetchSharedsubnetworks();
        fetchXPNResources();
    }, [project, packetMirrorData.regionName]);

    const fetchForwardingrulesByregion = async (regionName) => {
        try {
            let res = await LoadBalancerService.getFrontendServicesList(regionName);
            if (res.items) {
                setCollectorDestinationList(res.items)
            } else {
                setCollectorDestinationList([])
            }
        } catch (error) {
            console.log(`Error while Fetching Frontend services" ${error.message}`);
        }
    }

    const filterForwardingrulesBynetwork = (collectorIlbs, networkUrl) => {
        return collectorIlbs.filter((ilb) => ilb.network === networkUrl && ilb.isMirroringCollector === true);
    };

    useEffect(() => {
        let ForwardingRules = collectorDestinationList;
        if (packetMirrorData.network.url) {
            ForwardingRules = filterForwardingrulesBynetwork(ForwardingRules, packetMirrorData.network.url);
        }
        setFilteredForwardingRules(ForwardingRules);
    }, [collectorDestinationList, packetMirrorData.network.url, packetMirrorData.regionName])

    const handleNext = () => {
        if (activeStep === steps.length - 1) {
            if (!mirrorDefault) {

                if (ranges.length !== 0) {
                    const updatedData = {
                        ...packetMirrorData,
                        filter: {
                            ...packetMirrorData?.filter,
                            cidrRanges: ranges
                        }
                    };
                    handleSubmit(updatedData);
                } else {
                    const updatedData = {
                        ...packetMirrorData,
                        filter: {
                            ...packetMirrorData?.filter,
                            cidrRanges: []
                        }
                    }
                    handleSubmit(updatedData)
                }
            }
            else {
                const updatedData = {
                    ...packetMirrorData,
                    filter: {
                        cidrRanges: [],
                        IPProtocols: [],
                        direction: "BOTH"
                    }
                }
                handleSubmit(updatedData)
            }
        } else {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }
    };

    const handleStepClick = (stepIndex) => {
        if (stepIndex >= 0 && stepIndex < steps.length) {
            setActiveStep(stepIndex);
        }
    };

    const handleProtocolChange = (protocol) => {
        const currentProtocols = packetMirrorData?.filter?.IPProtocols || [];
        const protocolExists = currentProtocols.includes(protocol);
        let updatedProtocols;
        if (protocolExists) {
            updatedProtocols = currentProtocols.filter(p => p !== protocol);
        } else {
            updatedProtocols = [...currentProtocols, protocol];
        }
        setPacketMirrorData(prevState => ({
            ...prevState,
            filter: {
                ...prevState.filter,
                IPProtocols: updatedProtocols,
            }
        }));
    };

    const handleDirectionChange = (event) => {
        const direction = event.target.value;
        setPacketMirrorData(prevData => ({
            ...prevData,
            filter: {
                ...prevData.filter,
                direction: direction
            }
        }));
    };

    const handlePacketMirrorName = (e, validID, valid) => {
        const newName = e.target.value;
        if (!nameReg.test(newName)) {
            setNameError("Enter lowercases, numbers, and hypens");
        } else {
            setNameError("");
        }

        packetMirrorForm.set({ ...packetMirrorForm.get(), [validID]: valid });
        setPacketMirrorData({
            ...packetMirrorData,
            name: e.target.value,
        });
    }

    const handleMirrorChange = (event) => {
        const isFilterTraffic = event.target.value === 'true';
        setMirrorDefault(isFilterTraffic);
    };

    const handleProtocol = (event) => {
        const isCustomProtocol = event.target.value === 'true';
        setSpecificProtocol(isCustomProtocol);
        if (!isCustomProtocol) {
            setPacketMirrorData((prevState) => ({
                ...prevState,
                filter: {
                    ...prevState.filter,
                    IPProtocols: []
                }
            }));
        }

    };

    const handlePolicyPriority = (e) => {
        const newValue = e.target.value.trim();
        const isValid = newValue !== "" && parseInt(newValue) > 0 && parseInt(newValue) <= 1000;
        setPacketMirrorData({
            ...packetMirrorData,
            priority: newValue === "" ? "" : parseInt(newValue),
        });
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const isStepValid = () => {
        switch (activeStep) {
            case 0:
                return (
                    packetMirrorData.name !== null &&
                    nameError === "" &&
                    packetMirrorData.priority !== null &&
                    packetMirrorData.region !== null
                );
            case 1:
                return packetMirrorData.network.url !== null;
            case 2:
                const { mirroredResources } = packetMirrorData;
                const tagsValid = enableNetworktags ? (mirroredResources?.tags?.length > 0) : false;
                const subnetworksValid = enableSubnetwork ? (mirroredResources?.subnetworks?.length > 0) : false;
                const instancesValid = enableInstances ? (mirroredResources?.instances?.length > 0) : false;
                const isButtonDisabled = (
                    (tagsValid) ||
                    (subnetworksValid) ||
                    (instancesValid)
                );

                return isButtonDisabled;
            case 3:
                return packetMirrorData.collectorIlb.url !== null;

            case 4:
                if (mirrorDefault) {
                    return true
                }
                else {
                    if (specificProtocol && packetMirrorData?.filter?.IPProtocols?.length === 0) {
                        return false
                    }
                    if ((!allIPv4) && ipv4Ranges.length === 0) {
                        return false
                    }
                    if (allIPv6 === "custom" && ipv6Ranges.length === 0) {
                        return false
                    }
                }
            default:
                return true
        }
    };

    const handleEnableChange = (event) => {
        setPacketMirrorData({
            ...packetMirrorData,
            enable: event.target.value
        });
    };

    useEffect(() => {
        setIsNextButtonDisabled(!isStepValid());
    }, [activeStep, packetMirrorData, enableNetworktags, enableSubnetwork, enableInstances, specificProtocol, allIPv4, allIPv6, ipv4Ranges, ipv6Ranges]);

    const handleEnableSubnetworkChange = (event) => {
        const isChecked = event.target.checked;
        setEnableSubnetwork(isChecked);
    };

    useEffect(() => {

        if (packetMirrorData.region != null && packetMirrorData.network.url != null) {
            if (networkType === "within") {
                getInstances(packetMirrorData.network.url)
            } else {
                getInstancesUsingSharednetwork(packetMirrorData.network.url)
            }
        }
    }, [packetMirrorData.region, packetMirrorData.network.url, serviceProjects, project, networkType, activeStep])


    const handleEnableTagsChange = (event) => {
        const isChecked = event.target.checked;
        setEnableNetworkTags(isChecked);
    };

    const handleEnableInstancesChange = (event) => {
        const isChecked = event.target.checked;
        setEnableInstances(isChecked);
    };

    const handleAutocompleteCILBchange = (event, newValue, field) => {
        if (newValue) {
            setPacketMirrorData(prevData => ({
                ...prevData,
                ILBName: newValue.name,
                collectorIlb: {
                    ...prevData.collectorIlb,
                    url: newValue.selfLink
                }
            }));
        }
    };

    const handleRegionAutocompleteChange = (event, newValue, field) => {
        if (newValue) {
            var fieldName = field + 'Name';
            packetMirrorForm.set({ ...packetMirrorForm.get(), [field]: newValue.selfLink });
            setPacketMirrorData((prevData) => ({
                ...prevData,
                [fieldName]: newValue.name,
                [field]: newValue.selfLink,
                network: {
                    ...prevData.network,
                    url: null
                },
                networkName: null,
                mirroredResources: {
                    ...prevData.mirroredResources,
                    instances: []
                }
            }));
            fetchForwardingrulesByregion(newValue.name)
        }
    }

    useEffect(() => {
        if (packetMirrorData?.filter?.cidrRanges?.length > 0) {
            const ipv4 = packetMirrorData?.filter?.cidrRanges.filter(range => range.includes('.'));
            const ipv6 = packetMirrorData?.filter?.cidrRanges.filter(range => range.includes(':'));
            setIPv4Ranges(ipv4);
            setIPv6Ranges(ipv6);
        }
    }, [packetMirrorData]);

    const handleIpv4Change = useCallback((newValues) => {
        setIPv4Ranges(newValues);
    }, [ipv4Ranges]);

    const handleTagsChange = useCallback((newValues) => {
        setPacketMirrorData(prevValues => ({
            ...prevValues,
            mirroredResources: {
                ...prevValues.mirroredResources,
                tags: newValues
            }
        }));
    }, [packetMirrorData.mirroredResources.tags]);

    const handleIpv6Change = useCallback((newValues) => {
        setIPv6Ranges(newValues);
    }, [ipv6Ranges]);



    const handleNetworkTypeChange = (event) => {
        if (!isUpdate) {
            setNetworkType(event.target.value);
        }
        if (!isUpdate && event.target.value === "shared") {
            setPacketMirrorData((prevState) => ({
                ...prevState,
                sharedNetworkName: sharedNetwork.sharedNetworkName,
                network: {
                    ...prevState.network,
                    url: sharedNetwork.network.url
                },
                mirroredResources: {
                    ...prevState.mirroredResources,
                    subnetworks: [],
                    instances: []
                },
            }));

        } else if (!isUpdate && event.target.value === "within") {
            setPacketMirrorData((prevState) => ({
                ...prevState,
                networkName: network.networkName,
                network: {
                    ...prevState.network,
                    url: network.network.url
                },
                mirroredResources: {
                    ...prevState.mirroredResources,
                    subnetworks: [],
                    instances: []
                },
            }));

        }
    };


    const handleNetworkAutocomplete = (event, newValue, field) => {
        if (newValue) {
            var fieldName = field + 'Name';
            setNetwork({
                networkName: newValue.name,
                network: {
                    url: newValue.selfLink
                }
            })
            packetMirrorForm.set({ ...packetMirrorForm.get(), [field]: newValue.selfLink });
            setPacketMirrorData((prevState) => ({
                ...prevState,
                [fieldName]: newValue.name,
                network: {
                    ...prevState.network,
                    url: newValue.selfLink
                },
                mirroredResources: {
                    ...prevState.mirroredResources,
                    subnetworks: [],
                    instances: []
                },
            }));
        }
    };

    const handleSharedNetworkAutocomplete = (event, newValue, field) => {
        if (newValue) {
            var fieldName = field + 'Name';
            setSharedNetwork({
                sharedNetworkName: newValue.name,
                network: {
                    url: newValue.selfLink
                }
            })
            if (networkType === "shared") {
                packetMirrorForm.set({ ...packetMirrorForm.get(), [field]: newValue.selfLink });
                setPacketMirrorData((prevState) => ({
                    ...prevState,
                    [fieldName]: newValue.name,
                    network: {
                        ...prevState.network,
                        url: newValue.selfLink
                    },
                    mirroredResources: {
                        ...prevState.mirroredResources,
                        subnetworks: [],
                        instances: []
                    },
                }));
            }

        }
    };

    const handleSubnetworksChange = (event, value) => {

        const subnetworks = value.map(option => ({
            url: option.selfLink,
        }));

        setPacketMirrorData((prevState) => ({
            ...prevState,
            mirroredResources: {
                ...prevState.mirroredResources,
                subnetworks
            },
        }));
    };

    const getSelectedSubnetworks = () => {
        const subnetworks = packetMirrorData?.mirroredResources?.subnetworks || [];
        return subnetworks.map(subnetwork => {
            const listToSearch = networkType === "within" ? subnetworkList : sharedsubNetworkList;
            return listToSearch.find(option => option.selfLink === subnetwork.url);
        }).filter(Boolean);
    };


    const getSelectedInstances = () => {
        const instances = packetMirrorData?.mirroredResources?.instances || [];
        return instances.map(instance => {
            return instanceOptions.find(option => option.selfLink === instance.url);
        }).filter(Boolean);
    };


    const getSelectedSharednetworkInstances = () => {
        const instances = packetMirrorData?.mirroredResources?.instances || [];
        return instances.map(instance => {
            return sharednetworkinstanceOptions.find(option => option.selfLink === instance.url);
        }).filter(Boolean);
    };


    const handleInstancesChange = (event, value) => {
        const instances = value.map(option => ({
            url: option.selfLink,
        }));
        setPacketMirrorData((prevState) => ({
            ...prevState,
            mirroredResources: {
                ...prevState.mirroredResources,
                instances
            }
        }));
    };


    const handleServiceProjectsChange = (event, newValue) => {
        const selectedIds = newValue.map(option => option.id);
        // const updatedProjects = [...selectedIds, project];
        setServiceProjects(selectedIds);
        setPacketMirrorData((prevState) => ({
            ...prevState,
            mirroredResources: {
                ...prevState.mirroredResources,
                instances: []
            }
        }))
    };

    const handleIPv4filterChange = (event) => {
        const value = event.target.value === "true";
        setAllIpv4(value);
        if (value) {
            if (allIPv6 === "") {
                setIPv4Ranges([]);
            } else if (allIPv6 === "all") {
                setIPv4Ranges(["0.0.0.0/0"]);
            } else if (allIPv6 === "custom") {
                setIPv4Ranges(["0.0.0.0/0"]);
            }
        } else {
            if (allIPv6 === "" || allIPv6 === "custom" || allIPv6 === "all") {
                setIPv4Ranges([]);
            }
        }
    }

    const handleIPv6filterChange = (event) => {
        const value = event.target.value;
        setAllIpv6(value);
        if (value === "all") {
            setIPv6Ranges(["0::/0"]);
            if (allIPv4) {
                setIPv4Ranges(["0.0.0.0/0"]);
            }
        } else if (value === "") {
            setIPv6Ranges([]);
            if (allIPv4) {
                setIPv4Ranges([]);
            }
        } else if (value === "custom") {
            setIPv6Ranges([]);
            if (allIPv4) {
                setIPv4Ranges(["0.0.0.0/0"]);
            }
        }
    };

    const handleCancel = () => {
        navigate("/system/port_mirroring/gcp", { state: { tab: 2 } });
    }


    const handleSubmit = async (data) => {
        let a = _cloneDeep(data);
        const region = a.regionName;
        delete a.regionName
        delete a.networkName
        delete a.ILBName,
            delete a.zoneName,
            delete a.sharedNetworkName,
            delete a.subnetworkName
        if (!enableInstances) {
            a.mirroredResources.instances = []
        }
        if (!enableNetworktags) {
            a.mirroredResources.tags = []
        }
        if (!enableSubnetwork) {
            a.mirroredResources.subnetworks = []
        }
        if (mirrorDefault) {
            a.filter.cidrRanges = [];
            a.filter.IPProtocols = [];
            a.filter.direction = "BOTH";
        }
        if (isUpdate) {

            try {
                let res = await PacketMirrorService.updatePacketMirror(region, a.name, a);
                if (res.id) {
                    toast.success("Packet Mirror Updated Successfully");
                    navigate("/system/port_mirroring/gcp", { state: { tab: 2 } });
                }
                else {
                    throw new Error(res)
                }
            }
            catch (error) {
                toast.error(`Error while updating Packet Mirror: ${error.message}`);
                console.log(error.message);
            }
        }
        else {
            try {
                let res = await PacketMirrorService.createpacketMirroring(region, a);
                if (!res.error) {
                    toast.success("Packet Mirror created Successfully");
                    navigate("/system/port_mirroring/gcp", { state: { tab: 2 } });
                } else {
                    throw new Error(res);
                }

            } catch (error) {
                toast.error(`Error while creating Packet Mirror: ${error.message}`);
                console.log(error.message);
            }
        }
    };

    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" />;

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };


    return (
        <Grid container spacing={2}>
            <Grid item xs={12} container justifyContent="flex-end">
                <Box>
                    <Button
                        onClick={handleCancel}
                        variant="contained"
                        color="secondary"
                        className={classes.button}
                    >
                        Cancel
                    </Button>
                </Box>
            </Grid>
            <Grid item xs={12}>
                <Paper>
                    <Box p={5}>
                        <Grid item container xs={12} >
                            <Grid item xs={12} display="flex" direction='column' >
                                <Box>
                                    <Typography variant="h6">
                                        {readonly
                                            ? "View Packet Mirror"
                                            : (isUpdate
                                                ? 'Update Packet Mirror'
                                                : 'Create Packet Mirror')}
                                    </Typography>
                                </Box>
                                <Box mt={1}>
                                    <Typography variant="subtitle2">Defines the packet mirroring policy, including the specified source and destination.</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12} mt={4} >
                                <CustomStepper steps={steps} activeStep={activeStep} onStepClick={handleStepClick} />
                            </Grid>
                        </Grid>
                    </Box>
                </Paper>
            </Grid>

            <Grid item xs={12}>
                <Paper>
                    <Box p={5}>
                        {activeStep === 0 && (
                            <Grid item container xs={12} >
                                <Grid item xs={12} >
                                    <Typography variant="h6">Define Policy</Typography>
                                </Grid>

                                <Grid item container xs={12} mt={2} spacing={2}>
                                    <Grid item xs={6}>
                                        <FormControl fullWidth>
                                            <TextField
                                                disabled={readonly || isUpdate}
                                                fullWidth
                                                label="Name"
                                                name="name"
                                                value={packetMirrorData.name || ""}
                                                onChange={(e, validID, valid) => {
                                                    handlePacketMirrorName(e, validID, valid);
                                                }}
                                                error={nameError !== ""}
                                                helperText={`${nameError}`}
                                            ></TextField>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <FormControl fullWidth>
                                            <Autocomplete
                                                key={packetMirrorData.regionName}
                                                disabled={readonly || isUpdate}
                                                value={packetMirrorData.regionName || null}
                                                onChange={(event, newValue) => {
                                                    handleRegionAutocompleteChange(
                                                        event,
                                                        newValue
                                                            ? typeof newValue === "object"
                                                                ? newValue : null
                                                            : null,
                                                        "region")
                                                }}
                                                options={regionList}
                                                isOptionEqualToValue={(option, value) => option.name === value}
                                                getOptionLabel={(option) => typeof option === "object" ? `${option.name}` : option}
                                                renderInput={(params) => (
                                                    <TextField {...params} label="Region" />
                                                )}
                                            />
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Validator
                                            disabled={true}
                                            valueType="range"
                                            errorText="Policy priority cannot be empty"
                                            fullWidth
                                            label="Policy Priority"
                                            type="number"
                                            inputProps={{
                                                min: 1,
                                                max: 1000,
                                            }}
                                            name="priority"
                                            value={
                                                packetMirrorData.priority == null
                                                    ? ""
                                                    : packetMirrorData.priority
                                            }
                                            onChange={handlePolicyPriority}
                                        />
                                    </Grid>

                                    <Grid item xs={12}>
                                        <FormControl component="fieldset" margin="normal">
                                            <FormLabel >Policy Enforcement</FormLabel>
                                            <RadioGroup row value={packetMirrorData.enable} onChange={handleEnableChange}>
                                                <FormControlLabel value="TRUE" control={<Radio />} label="Enabled" />
                                                <FormControlLabel value="FALSE" control={<Radio />} label="Disabled" />
                                            </RadioGroup>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </Grid>
                        )
                        }
                        {
                            activeStep === 1 && (
                                <Grid item container xs={12} >
                                    <Grid item xs={12} >
                                        <Typography variant="h6">Select VPC Network</Typography>
                                    </Grid>
                                    <Grid item xs={12} mt={2} >
                                        <Typography variant="h8">Select the VPC network or networks where your mirrored and collector instances are located. You can only select networks that you have permissions to use.</Typography>
                                    </Grid>
                                    <Grid item container xs={12} mt={2} >
                                        <Grid item xs={12} >
                                            <FormControlLabel
                                                control={
                                                    <Radio
                                                        checked={peeredVPCnetwork === 0}
                                                        // onChange={handleNetworkChange}
                                                        value={0}
                                                    />
                                                }
                                                label="Mirrored source and collector destination are in the same VPC network"
                                            />
                                            {peeredVPCnetwork === 0 && (
                                                <Grid item container xs={12} >
                                                    <Grid item xs={12} ml={4}>
                                                        <FormControl component="fieldset" margin="normal">
                                                            <RadioGroup value={networkType} onChange={handleNetworkTypeChange}>
                                                                <FormControlLabel value="within" control={<Radio />} label={"Networks in this project"} />
                                                                <FormControlLabel value="shared" control={<Radio />} label={`Networks shared with me (from host project: '${project}')`} />
                                                            </RadioGroup>
                                                        </FormControl>
                                                    </Grid>

                                                    {networkType === "within" && (
                                                        <Grid item xs={6} ml={4}>
                                                            <FormControl fullWidth margin="normal">
                                                                <Autocomplete
                                                                    disabled={readonly || isUpdate}
                                                                    value={packetMirrorData.networkName}
                                                                    onChange={(event, newValue) =>
                                                                        handleNetworkAutocomplete(event, newValue, "network")
                                                                    }
                                                                    options={networkList}
                                                                    getOptionLabel={(option) => typeof option === 'object' ? `${option.name}` : option}
                                                                    renderInput={(params) => <TextField {...params} label="Network" />}
                                                                />
                                                            </FormControl>
                                                        </Grid>

                                                    )}

                                                    {networkType === "shared" && (
                                                        <Grid item xs={6} ml={4}>
                                                            <FormControl fullWidth margin="normal">
                                                                <Autocomplete
                                                                    disabled={readonly || isUpdate}
                                                                    value={packetMirrorData.sharedNetworkName}
                                                                    onChange={(event, newValue) =>
                                                                        handleSharedNetworkAutocomplete(event, newValue, "sharedNetwork")
                                                                    }
                                                                    // options={sharedNetworkList}
                                                                    options={sharedNetworkList}
                                                                    getOptionLabel={(option) => typeof option === 'object' ? `${option.name}` : option}
                                                                    renderInput={(params) => <TextField {...params} label="Shared Network" />}
                                                                />
                                                            </FormControl>
                                                        </Grid>
                                                    )}

                                                </Grid>
                                            )}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            )
                        }
                        {
                            activeStep === 2 && (
                                <Grid item container xs={12}>
                                    <Grid item xs={12} >
                                        <Typography variant="h6">Select Mirrored Source</Typography>
                                    </Grid>
                                    <Grid item xs={12} mt={2} >
                                        <Typography variant="h8">Specify the Source that will be Mirrored Packet Mirroring capture all the ingress and egress traffic of mirrored instance</Typography>
                                    </Grid>
                                    <Grid item xs={12} p={1}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={enableSubnetwork}
                                                    onChange={handleEnableSubnetworkChange}
                                                    name="myCheckbox"
                                                />
                                            }
                                            label="select  one or more subnetworks"
                                        />
                                    </Grid>
                                    {enableSubnetwork && (
                                        <Grid item xs={6} ml={4}>
                                            <Autocomplete
                                                disabled={readonly}
                                                multiple
                                                limitTags={2}
                                                id="checkboxes-tags-demo"
                                                options={networkType === "within" ? subnetworkList : sharedsubNetworkList}
                                                disableCloseOnSelect
                                                onChange={(event, newValue) => {
                                                    if (newValue.length < 6) {
                                                        handleSubnetworksChange(event, newValue);
                                                    }
                                                }}
                                                value={getSelectedSubnetworks()}
                                                getOptionLabel={(option) => option.name}
                                                renderOption={(props, option, { selected }) => {
                                                    const { key, ...optionProps } = props;
                                                    return (
                                                        <li key={key} {...optionProps}>
                                                            <Checkbox
                                                                icon={icon}
                                                                checkedIcon={checkedIcon}
                                                                style={{ marginRight: 8 }}
                                                                checked={selected}
                                                            />
                                                            {option.name}
                                                        </li>
                                                    );
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Subnetworks"
                                                        placeholder="Select subnetworks"
                                                        error={enableSubnetwork && getSelectedSubnetworks().length === 0}
                                                        helperText={
                                                            getSelectedSubnetworks().length === 0
                                                                ? <span style={{ color: '#ED4141' }}>This field cannot be empty</span> // Show error if empty
                                                                : getSelectedSubnetworks().length < 6
                                                                    ? <span>You can select  maximum of 5 subnetworks</span> // Show max limit message
                                                                    : ""
                                                        }
                                                    />
                                                )}

                                                ChipProps={{
                                                    className: classes.chip,
                                                }}
                                            />

                                        </Grid>
                                    )}
                                    <Grid item xs={12} p={1}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={enableNetworktags}
                                                    onChange={handleEnableTagsChange}
                                                    name="myCheckbox"
                                                />
                                            }
                                            label="select with network tags"
                                        />
                                    </Grid>
                                    {enableNetworktags && (
                                        <Grid item xs={6} ml={4}>
                                            <FormControl fullWidth>
                                                <MultipleInputs
                                                    name="tags"
                                                    label="Network Tags"
                                                    placeholder="Add tags"
                                                    limit={5}
                                                    value={packetMirrorData.mirroredResources?.tags || []}
                                                    valueType="username"
                                                    allowEmpty={false}
                                                    error={enableNetworktags && (packetMirrorData?.mirroredResources?.tags === undefined || packetMirrorData?.mirroredResources?.tags?.length === 0)}
                                                    errorText={
                                                        enableNetworktags && (packetMirrorData?.mirroredResources?.tags === undefined || packetMirrorData?.mirroredResources?.tags?.length === 0)
                                                            ? "This field cannot be empty" : ""
                                                    }
                                                    unique={true}
                                                    onChange={handleTagsChange}
                                                    ChipProps={{
                                                        className: classes.chip,
                                                    }}
                                                />
                                            </FormControl>
                                        </Grid>
                                    )}

                                    <Grid item xs={12} p={1}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={enableInstances}
                                                    onChange={handleEnableInstancesChange}
                                                    name="myCheckbox"
                                                />
                                            }
                                            label="select individual instance"
                                        />
                                    </Grid>
                                    {enableInstances && (

                                        <Grid item xs={6} ml={4}>
                                            {networkType === 'shared' ? (
                                                <Grid>
                                                    <Box>
                                                        <Autocomplete
                                                            disabled={readonly}
                                                            multiple
                                                            limitTags={3}
                                                            id="checkboxes-service-projects"
                                                            options={serviceProjectOptions}
                                                            disableCloseOnSelect
                                                            onChange={handleServiceProjectsChange}
                                                            value={serviceProjectOptions.filter(option => serviceProjects.includes(option.id))} // Set based on selected IDs
                                                            getOptionLabel={(option) => option.id}  // Display the id as the label
                                                            renderOption={(props, option, { selected }) => {
                                                                const { key, ...optionProps } = props;
                                                                return (
                                                                    <li key={key} {...optionProps}>
                                                                        <Checkbox
                                                                            icon={icon}
                                                                            checkedIcon={checkedIcon}
                                                                            style={{ marginRight: 8 }}
                                                                            checked={selected}
                                                                        />
                                                                        {option.id}
                                                                    </li>
                                                                );
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="Service Projects"
                                                                    placeholder="Service Projects"
                                                                    helperText={<span>VM instances will be fetched from host project and selected service projects</span>}
                                                                />
                                                            )}
                                                            ChipProps={{
                                                                className: classes.chip,
                                                            }}
                                                        />

                                                    </Box>
                                                    <Box>
                                                        <Autocomplete
                                                            disabled={readonly || (networkType === 'shared' && serviceProjects.length === 0)}
                                                            multiple
                                                            limitTags={2}
                                                            id="checkboxes-tags-demo"
                                                            options={sharednetworkinstanceOptions} //shared instancesoptions
                                                            disableCloseOnSelect
                                                            onChange={handleInstancesChange} //shared instancescahnge
                                                            value={getSelectedSharednetworkInstances()}
                                                            getOptionLabel={(option) => option.name}
                                                            renderOption={(props, option, { selected }) => {
                                                                const { key, ...optionProps } = props;
                                                                return (
                                                                    <li key={key} {...optionProps}>
                                                                        <Checkbox
                                                                            icon={icon}
                                                                            checkedIcon={checkedIcon}
                                                                            style={{ marginRight: 8 }}
                                                                            checked={selected}
                                                                        />
                                                                        {option.name}
                                                                    </li>
                                                                );
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="Instances"
                                                                    placeholder="Instances"
                                                                    error={!(networkType === 'shared' && serviceProjects.length === 0) && enableInstances && getSelectedSharednetworkInstances()?.length === 0} // Disable error when disabled is true
                                                                    helperText={
                                                                        (networkType === 'shared' && serviceProjects.length === 0)
                                                                            ? <span style={{ color: 'grey' }}>This field is disabled</span>
                                                                            : getSelectedSharednetworkInstances()?.length === 0
                                                                                ? <span style={{ color: '#ED4141' }}>This field cannot be empty</span>
                                                                                : getSelectedSharednetworkInstances()?.length < 50
                                                                                    ? <span>You can select a maximum of 50 instances</span>
                                                                                    : ""
                                                                    }
                                                                />
                                                            )}
                                                            ChipProps={{
                                                                className: classes.chip,
                                                            }}
                                                        />
                                                    </Box>
                                                </Grid>
                                            ) : (
                                                <Box mt={1}>
                                                    <Autocomplete
                                                        disabled={readonly}
                                                        multiple
                                                        limitTags={2}
                                                        id="checkboxes-tags-demo"
                                                        options={instanceOptions}
                                                        disableCloseOnSelect
                                                        onChange={handleInstancesChange}
                                                        value={getSelectedInstances()}
                                                        getOptionLabel={(option) => option.name}
                                                        renderOption={(props, option, { selected }) => {
                                                            const { key, ...optionProps } = props;
                                                            return (
                                                                <li key={key} {...optionProps}>
                                                                    <Checkbox
                                                                        icon={icon}
                                                                        checkedIcon={checkedIcon}
                                                                        style={{ marginRight: 8 }}
                                                                        checked={selected}
                                                                    />
                                                                    {option.name}
                                                                </li>
                                                            );
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Instances"
                                                                placeholder="Instances"
                                                                error={enableInstances && getSelectedInstances()?.length === 0}
                                                                helperText={
                                                                    getSelectedInstances()?.length === 0
                                                                        ? <span style={{ color: '#ED4141' }}>This field is cannot be empty</span>
                                                                        : getSelectedInstances()?.length < 50
                                                                            ? <span>You can select the maximum of 50 Intances</span>
                                                                            : ""
                                                                }
                                                            />
                                                        )}
                                                        ChipProps={{
                                                            className: classes.chip,
                                                        }}
                                                    />
                                                </Box>
                                            )}
                                        </Grid>
                                    )}

                                </Grid>
                            )
                        }

                        {activeStep === 3 && (
                            <Grid item container xs={12} >
                                <Grid item xs={12} >
                                    <Typography variant="h6">Select Collector Destination</Typography>
                                </Grid>
                                <Grid item xs={12} mt={2} >
                                    <Typography variant="h8">Select an Internal passthrough network load balancer traffic across your collector instance (the backend instances). which collect all the mirrored traffic. the load balancer must have a forwarding rule specially for packet mirroring</Typography>
                                </Grid>

                                <Grid item xs={6}>
                                    <FormControl fullWidth margin="normal">
                                        <Autocomplete
                                            disabled={readonly}
                                            value={packetMirrorData.ILBName}
                                            onChange={(event, newValue) =>
                                                handleAutocompleteCILBchange(event, newValue, "ILB")
                                            }
                                            options={filteredForwardingrules}
                                            getOptionLabel={(option) =>
                                                typeof option === "object"
                                                    ? `${option.name}`
                                                    : option
                                            }
                                            renderInput={(params) => (
                                                <TextField {...params} label="Collector destination" />
                                            )}
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>

                        )
                        }
                        {activeStep === 4 && (
                            <Grid item container xs={12} >
                                <Grid item xs={12} >
                                    <Typography variant="h6">Select mirrored traffic</Typography>
                                </Grid>
                                <Grid item xs={12} mt={2} >
                                    <Typography variant="h8">Specify the traffic to mirror. By default, all ingress and egress is mirrored. If you want to reduce the amount of mirrored traffic, add filters to mirror only certain traffic.</Typography>

                                </Grid>
                                <Grid item xs={12} >
                                    <FormControl component="fieldset" margin="normal">
                                        <RadioGroup
                                            value={mirrorDefault ? "true" : "false"}
                                            onChange={handleMirrorChange}
                                        >
                                            <FormControlLabel
                                                value="true"
                                                control={<Radio />}
                                                label="Mirror all IPv4 traffic (default)"
                                            />
                                            <FormControlLabel
                                                value="false"
                                                control={<Radio />}
                                                label="Mirror filter traffic"
                                            />
                                        </RadioGroup>
                                    </FormControl>
                                </Grid>

                                {!mirrorDefault && (
                                    <Grid item xs={12} container >
                                        <Grid item xs={12} >
                                            <FormControl component="fieldset" margin="normal">
                                                <FormLabel>Protocol filters</FormLabel>
                                                <RadioGroup value={specificProtocol} onChange={handleProtocol}>
                                                    <FormControlLabel value="false" control={<Radio />} label="Allow all protocols" />
                                                    <FormControlLabel value="true" control={<Radio />} label="Allow specific protocols" />
                                                </RadioGroup>
                                            </FormControl>

                                            {specificProtocol && (
                                                <Grid item xs={12} container>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={packetMirrorData?.filter?.IPProtocols?.includes('icmp') || false}
                                                                onChange={() => handleProtocolChange('icmp')}
                                                            />
                                                        }
                                                        label="ICMP"
                                                    />
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={packetMirrorData?.filter?.IPProtocols?.includes('tcp') || false}
                                                                onChange={() => handleProtocolChange('tcp')}
                                                            />
                                                        }
                                                        label="TCP"
                                                    />
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={packetMirrorData?.filter?.IPProtocols?.includes('udp') || false}
                                                                onChange={() => handleProtocolChange('udp')}
                                                            />
                                                        }
                                                        label="UDP"
                                                    />
                                                </Grid>
                                            )}
                                        </Grid>

                                        <Grid item xs={12}>
                                            <FormControl component="fieldset" margin="normal">
                                                <FormLabel>IPv4 range filters</FormLabel>
                                                <RadioGroup value={allIPv4 ? "true" : "false"} onChange={handleIPv4filterChange}>
                                                    <FormControlLabel value="true" control={<Radio />} label="Allow all IPv4 ranges (0.0.0.0/0)" />
                                                    <FormControlLabel value="false" control={<Radio />} label="Allow specific IPv4 ranges" />
                                                </RadioGroup>
                                            </FormControl>
                                        </Grid >

                                        {!allIPv4 && (
                                            <Grid item container xs={12}>
                                                <Grid item xs={6}>

                                                    <MultipleInputs
                                                        disabled={readonly}
                                                        name="ipv4 Input"
                                                        value={ipv4Ranges || []}
                                                        label="IPv4"
                                                        placeholder="Ipv4 ranges"
                                                        valueType="ipv4"
                                                        error={!allIPv4 && (ipv4Ranges.length === 0)}
                                                        errorText={!allIPv4 && (ipv4Ranges.length === 0)
                                                            ? "This field cannot be empty"
                                                            : ""}
                                                        allowEmpty={false}
                                                        unique={true}
                                                        onChange={handleIpv4Change}
                                                        ChipProps={{
                                                            className: classes.chip,
                                                        }}
                                                    />
                                                </Grid >
                                            </Grid >
                                        )}

                                        <Grid item xs={12}>
                                            <FormControl component="fieldset" margin="normal">
                                                <FormLabel>IPv6 range filters</FormLabel>
                                                <RadioGroup value={allIPv6} onChange={handleIPv6filterChange}>
                                                    <FormControlLabel value="" control={<Radio />} label="None" />
                                                    <FormControlLabel value="all" control={<Radio />} label="Allow all IPv6 ranges (::/0)" />
                                                    <FormControlLabel value="custom" control={<Radio />} label="Allow specific IPv6 ranges" />
                                                </RadioGroup>
                                            </FormControl>
                                        </Grid >
                                        {allIPv6 === 'custom' && (
                                            <Grid item container xs={12}>
                                                <Grid item xs={6}>

                                                    <MultipleInputs
                                                        disabled={readonly}
                                                        name="ipv6 Input"
                                                        value={ipv6Ranges || []}
                                                        label="IPv6"
                                                        placeholder="Ipv6cidr ranges"
                                                        valueType="ipv6cidr"
                                                        allowEmpty={false}
                                                        error={allIPv6 && (ipv6Ranges.length === 0)}
                                                        errorText={allIPv6 && (ipv6Ranges.length === 0)
                                                            ? "This field cannot be empty"
                                                            : ""}
                                                        unique={true}
                                                        onChange={handleIpv6Change}
                                                        ChipProps={{
                                                            className: classes.chip,
                                                        }}
                                                    />
                                                </Grid >
                                            </Grid >)}

                                        <Grid item xs={12}>
                                            <FormControl component="fieldset" margin="normal">
                                                <FormLabel>Traffic direction</FormLabel>
                                                <RadioGroup
                                                    value={packetMirrorData?.filter?.direction}
                                                    onChange={handleDirectionChange}
                                                >
                                                    <FormControlLabel value="BOTH" control={<Radio />} label="Allow both ingress and egress traffic" />
                                                    <FormControlLabel value="INGRESS" control={<Radio />} label="Allow ingress traffic only" />
                                                    <FormControlLabel value="EGRESS" control={<Radio />} label="Allow egress traffic only" />
                                                </RadioGroup>
                                            </FormControl>
                                        </Grid >
                                    </Grid>
                                )}


                            </Grid>

                        )
                        }

                    </Box>
                </Paper>
                <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2, pb: 6 }}>
                    <Button
                        disabled={activeStep === 0}
                        onClick={handleBack}
                        variant="contained"
                        color="secondary"
                        sx={{ mr: 1 }}
                    >
                        Back
                    </Button>
                    <Box sx={{ flex: '1 1 auto' }} />
                    <Button
                        // disabled
                        onClick={handleNext}
                        disabled={isNextButtonDisabled}
                        variant="contained"
                        color="primary"
                    >
                        {(activeStep === steps.length - 1)
                            ? (isUpdate ? 'Update' : 'Save')
                            : 'Next'
                        }
                    </Button>
                </Box>
            </Grid>

        </Grid >

    );
};

export default CreatePacketMirror;
